import { render, staticRenderFns } from "./MisInscripciones.vue?vue&type=template&id=4d53be82"
import script from "./MisInscripciones.vue?vue&type=script&lang=js"
export * from "./MisInscripciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports